import { Box } from '@mui/material';
import React from 'react';

function ExperimentMachinePageFooter() {
  return (
    <Box style={{ width: "100%", height: "7vh", marginTop: 20}}>
        <h6 style={{color: '#AAAAAA', display: 'inline', marginLeft: 30, marginTop: 20}}>Copyright 2020 ⓒ NeuroTx. All RIGHT RESERVED</h6>
    </Box>
  );
}

export default ExperimentMachinePageFooter;